import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routerConfig.jsx';

function Routes() {
  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  );
}

export default Routes;